<template>
  <!-- Card 17trt6jd8uu, etapa 4: selo. Icone provisório (círculo colorido com
       ícone); quando a Pitch enviar as imagens, troca-se aqui. Selo não
       conquistado fica mais transparente. A explicação aparece ao passar o
       mouse (ou tocar). -->
  <v-tooltip top max-width="260" open-on-click>
    <template #activator="{ on, attrs }">
      <span
        class="bdg"
        :class="{ 'is-locked': !owned }"
        :style="{ '--bdg': badge.color, '--bdg-size': size + 'px' }"
        role="img"
        tabindex="0"
        :aria-label="label"
        v-bind="attrs"
        v-on="on"
      >
        <v-icon :size="Math.round(size * 0.55)" color="#fff">{{
          badge.icon
        }}</v-icon>
        <v-icon
          v-if="badge.accent"
          class="bdg__accent"
          :size="Math.round(size * 0.32)"
          color="#FFE27A"
          >{{ badge.accent }}</v-icon
        >
        <span v-if="owned && badge.count > 1" class="bdg__count">{{
          badge.count
        }}</span>
      </span>
    </template>
    <div class="bdg-tip">
      <b>{{ label }}</b>
      <div>{{ description }}</div>
    </div>
  </v-tooltip>
</template>

<script>
export default {
  name: "BadgeIcon",

  props: {
    badge: { type: Object, required: true },
    size: { type: Number, default: 30 },
    // Quando não informado, vale se a pessoa já ganhou o selo.
    earned: { type: Boolean, default: null },
  },

  computed: {
    owned() {
      return this.earned === null ? this.badge.count > 0 : this.earned;
    },
    label() {
      const key = `pitchCoins.badges.${this.badge.code}.name`;
      return this.$te(key) ? this.$t(key) : this.badge.name;
    },
    description() {
      const key = `pitchCoins.badges.${this.badge.code}.description`;
      // `{n}` e a quantidade em vigor: o administrativo pode ajustar.
      return this.$te(key)
        ? this.$t(key, { n: this.badge.threshold })
        : this.badge.description;
    },
  },
};
</script>

<style scoped>
.bdg {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: var(--bdg-size);
  height: var(--bdg-size);
  border-radius: 50%;
  background: var(--bdg);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.18);
  cursor: help;
}

.bdg__accent {
  position: absolute;
  top: -2px;
  right: -2px;
}

.bdg.is-locked {
  opacity: 0.32;
  filter: grayscale(0.6);
  box-shadow: none;
}

.bdg:focus-visible {
  outline: 2px solid var(--bdg);
  outline-offset: 2px;
}

.bdg__count {
  position: absolute;
  right: -4px;
  bottom: -4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 9px;
  background: #fff;
  color: var(--bdg);
  border: 1px solid var(--bdg);
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 16px;
  text-align: center;
}

.bdg-tip {
  font-size: 0.8rem;
  line-height: 1.35;
}
</style>
